import styles from './VideoUnitEditor.module.css';

interface VideoUnitEditorProps {
  onChange: (updates: { videoId?: string }) => void;
  videoId?: string;
}

export function VideoUnitEditor({
  onChange,
  videoId,
}: VideoUnitEditorProps) {
  const trimmedVideoId = videoId?.trim() ?? '';
  const previewImage = trimmedVideoId
    ? `https://img.youtube.com/vi/${encodeURIComponent(trimmedVideoId)}/hqdefault.jpg`
    : '';

  return (
    <div className={styles.root}>
      <label className={styles.field}>
        <span className={styles.label}>YouTube video ID</span>
        <input
          className={styles.input}
          onChange={(event) => {
            onChange({ videoId: event.target.value });
          }}
          type="text"
          value={videoId ?? ''}
        />
      </label>

      <div className={styles.preview}>
        <p className={styles.previewLabel}>Preview</p>
        <div className={styles.previewSurface}>
          {previewImage ? (
            <img
              alt="Inline video thumbnail preview"
              className={styles.thumbnail}
              src={previewImage}
            />
          ) : (
            <span className={styles.placeholder}>
              Add a YouTube video ID to preview the inline video block.
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
